<template>
  <div>
    <el-form label-width="90px" @submit.native.prevent>
      <el-row>
        <el-col :span="12">
          <el-form-item label="条件">
            <el-input
              v-model="query.keyword"
              maxlength="30"
              placeholder="姓名、身份证号、专家编号"
              clearable
              @keyup.enter.native="onSearch"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-button icon="el-icon-search" @click="onSearch">搜索</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table :data="tableData" v-loading="loading" border fit stripe>
      <el-table-column
        prop="sortNum"
        label="序号"
        width="60"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="mavinName"
        label="姓名"
        width="130"
      ></el-table-column>
      <el-table-column
        prop="mavinNo"
        label="身份证/专家编号"
        width="150"
        sortable
      >
        <template slot-scope="scope">
          <div>{{ scope.row.safeIdCard }}</div>
          <div>{{ scope.row.mavinNo }}</div>
        </template>
      </el-table-column>
      <el-table-column label="性别/民族/年龄/现任职称" width="175">
        <template slot-scope="scope">
          {{ scope.row.sex }}、{{ scope.row.nation }}、{{ scope.row.age }}
          <div>
            <el-tag size="small">{{ scope.row.levelName }}</el-tag>
            {{ scope.row.appellation }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="工作单位/单位所在地">
        <template slot-scope="scope">
          <div>{{ scope.row.deptName }}</div>
          <div>{{ scope.row.areaName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="可评审专业">
        <template slot-scope="scope">
          <el-tag size="small">1、{{ scope.row.allSpeName1 }}</el-tag>
          <div v-show="scope.row.allSpeName2">
            2、{{ scope.row.allSpeName2 }}
          </div>
          <div v-show="scope.row.allSpeName3">
            3、{{ scope.row.allSpeName3 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="130">
        <template slot-scope="scope">
          <el-button
            size="smalll"
            type="text"
            icon="el-icon-delete"
            v-show="allowEdit"
            @click="handleDelete(scope.row.mavinEid)"
          >
            删除
          </el-button>
          <el-button
            size="smalll"
            type="text"
            @click="handleView(scope.row.mavinEid)"
          >
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="onSearch"
      @current-change="onSearch"
      :current-page.sync="query.pageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size.sync="query.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import { eventBus } from '@/utils/event-bus.js';
import { seledList, seledDelete } from '@/api/shares/mavin.js';

export default {
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 10
      },
      loading: false,
      tableData: [],
      total: 0,
      keyword: ''
    };
  },
  props: {
    allowEdit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /** 搜索按钮操作 */
    onSearch() {
      this.list();
    },
    handleView(mavinEid) {
      window.open(`/mavin/review/${mavinEid}`, 'handleView');
    },
    handleDelete(mavinEid) {
      this.$confirm('从已选专家中删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        seledDelete(this.$route.params.shareEid, mavinEid).then(res => {
          this.loading = false;
          this.list();
        });
      });
    },
    list() {
      this.loading = true;
      seledList(this.$route.params.shareEid, this.query).then(res => {
        this.loading = false;
        this.tableData = res.datas;
        this.total = res.totalRecords;

        this.$emit('handleSeled', this.total);
      });
    }
  },
  created() {
    eventBus.$on('eventSeled', () => {
      this.onSearch();
    });
    this.list();
  }
};
</script>

<style></style>
